export default __webpack_public_path__ + "static/seal-576a4a3bc71e3a9e6bbc1c197c605910.png";